/**
 * A custom error for visualization workspace hydration errors.
 */
export class HydrationError extends Error {
  #id: string;
  constructor(id: string, message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "HydrationError";
    this.#id = id;
  }
  get id() {
    return this.#id;
  }
}
